angular.module('picmonicng').component('trackSelector', {
  templateUrl: '/templates/app/components/track-selector/track-selector.html',
  bindings: {
    ngModel: '<',
  },
  require: {
    ngModelCtrl: 'ngModel',
  },
  controller: [
    '$scope',
    '$filter',
    'Pathways',
    'Tracks',
    'MarketOptionsConfig',
    'UserService',
    'Playlists',
    '$q',
    function ($scope, $filter, Pathways, Tracks, MarketOptionsConfig, UserService, Playlists, $q) {
      var ctrl = this;

      ctrl.MarketOptionsConfig = MarketOptionsConfig;
      ctrl.market_id = UserService.user.lead;
      ctrl.pathwayIds = [];
      ctrl.trackIds = [];
      ctrl.excludedCardIds = [];
      ctrl.playlistsSectionOpen = false;
      ctrl.playlistIds = [];
      ctrl.initialLoading = true;

      ctrl.getSections = function () {
        ctrl.sections = Pathways.getv3({ market_id: ctrl.market_id });
        ctrl.playlists = Playlists.query();

        $q.all([ctrl.sections.$promise, ctrl.playlists.$promise]).then(function () {
          // Mark any tracks / playlists / pathways as already selected
          ctrl.trackIds = ctrl.ngModel.track_ids;
          ctrl.playlistIds = ctrl.ngModel.playlist_ids;
          ctrl.excludedCardIds = ctrl.ngModel.excluded_card_ids;
          ctrl.pathwayIds = ctrl.ngModel.pathway_ids;

          // If you have any playlsits already selected open pathways
          if (ctrl.playlistIds.length) {
            ctrl.playlistsSectionOpen = true;
          }

          // If you have any pathways selected open that section
          angular.forEach(ctrl.sections, function (section) {
            angular.forEach(section.pathways, function (pathway) {
              if (ctrl.pathwayIds.indexOf(pathway.pathway_id) !== -1) {
                section.open = true;
              }
            });
          });

          ctrl.initialLoading = false;
        });
      };

      ctrl.getTracks = function (pathway) {
        if (pathway.tracks) {
          return $q.resolve(pathway.tracks);
        }
        pathway.tracks = Pathways.queryv3({
          pathway_id: pathway.pathway_id,
          resource: 'tracks',
          visible_in_categorization: 1,
          show_hidden: 0,
        });

        return pathway.tracks.$promise;
      };

      ctrl.getPicmonics = function (track) {
        if (track.picmonics) {
          return;
        }

        track.picmonics = Tracks.get({
          track_id: track.track_id,
          resource: 'picmonics',
        });

        return track.picmonics.$promise;
      };

      ctrl.getPlaylistPicmonics = function (playlist) {
        if (playlist.full_picmonics) {
          return;
        }

        playlist.full_picmonics = Playlists.query({
          playlist_id: playlist.playlist_id,
          resource: 'picmonics',
        });

        return playlist.full_picmonics.$promise;
      };

      // recursive
      ctrl.selectPathway = function (pathways, pathway) {
        if (ctrl.pathwayIds.indexOf(pathway.pathway_id) === -1) {
          ctrl.pathwayIds.push(pathway.pathway_id);
        }

        ctrl.getTracks(pathways).then(function () {
          ctrl.selectChildren(pathways, pathway);

          angular.forEach(pathway.tracks, function (childTrack) {
            ctrl.selectTrack(childTrack);
          });
        });
      };

      ctrl.selectChildren = function (pathways, pathway) {
        angular.forEach(
          $filter('filter')(pathways.tracks, { parent_id: pathway.pathway_id }, true),
          function (childPathway) {
            ctrl.selectPathway(pathways, childPathway);

            angular.forEach(childPathway.tracks, function (childTrack) {
              ctrl.selectTrack(childTrack);
            });
          }
        );
      };

      ctrl.removePathway = function (pathway, pathways) {
        index = ctrl.pathwayIds.indexOf(pathway.pathway_id);

        if (index !== -1) {
          ctrl.pathwayIds.splice(index, 1);
        }

        ctrl.getTracks(pathways).then(function () {
          angular.forEach(
            $filter('filter')(pathways.tracks, { parent_id: pathway.pathway_id }, true),
            function (childPathway) {
              ctrl.removePathway(childPathway, pathways);

              angular.forEach(childPathway.tracks, function (childTrack) {
                ctrl.removeTrack(childTrack);
              });
            }
          );

          angular.forEach(pathway.tracks, function (childTrack) {
            ctrl.removeTrack(childTrack);
          });
        });
      };

      ctrl.setViewValue = function () {
        ctrl.ngModelCtrl.$setViewValue({
          track_ids: angular.copy(ctrl.trackIds),
          excluded_card_ids: angular.copy(ctrl.excludedCardIds),
          playlist_ids: angular.copy(ctrl.playlistIds),
          pathway_ids: angular.copy(ctrl.pathwayIds),
        });
      };

      ctrl.selectTrack = function (track) {
        if (ctrl.trackIds.indexOf(track.track_id) === -1) {
          ctrl.trackIds.push(track.track_id);

          if (track.picmonics) {
            angular.forEach(track.picmonics.cards, function (trackPicmonic) {
              ctrl.includePicmonic(trackPicmonic);
            });
          }

          ctrl.setViewValue();
        }
      };

      ctrl.removeTrack = function (track) {
        index = ctrl.trackIds.indexOf(track.track_id);

        if (index !== -1) {
          ctrl.trackIds.splice(index, 1);

          if (track.picmonics) {
            angular.forEach(track.picmonics.cards, function (trackPicmonic) {
              ctrl.includePicmonic(trackPicmonic);
            });
          }

          ctrl.setViewValue();
        }
      };

      ctrl.selectPicmonic = function (track, picmonic) {
        if (ctrl.trackExists(track)) {
          ctrl.includePicmonic(picmonic);
        } else {
          ctrl.selectTrack(track);

          angular.forEach(track.picmonics.cards, function (trackPicmonic) {
            if (picmonic.card_id !== trackPicmonic.card_id) {
              ctrl.excludePicmonic(trackPicmonic);
            }
          });
        }
      };

      ctrl.selectPlaylistPicmonic = function (playlist, picmonic) {
        if (ctrl.playlistExists(playlist)) {
          ctrl.includePicmonic(picmonic);
        } else {
          ctrl.selectPlaylist(playlist);

          angular.forEach(playlist.full_picmonics, function (playlistPicmonic) {
            if (picmonic.card_id !== playlistPicmonic.card_id) {
              ctrl.excludePicmonic(playlistPicmonic);
            }
          });
        }
      };

      ctrl.includePicmonic = function (picmonic) {
        index = ctrl.excludedCardIds.indexOf(picmonic.card_id);

        if (index !== -1) {
          ctrl.excludedCardIds.splice(index, 1);
        }

        ctrl.setViewValue();
      };

      ctrl.excludePicmonic = function (picmonic) {
        index = ctrl.excludedCardIds.indexOf(picmonic.card_id);

        if (index === -1) {
          ctrl.excludedCardIds.push(picmonic.card_id);
        }

        ctrl.setViewValue();
      };

      ctrl.selectPlaylist = function (playlist) {
        if (ctrl.playlistIds.indexOf(playlist.playlist_id) === -1) {
          ctrl.playlistIds.push(playlist.playlist_id);
        }

        ctrl.setViewValue();
      };

      ctrl.removePlaylist = function (playlist) {
        index = ctrl.playlistIds.indexOf(playlist.playlist_id);

        if (index !== -1) {
          ctrl.playlistIds.splice(index, 1);
        }

        ctrl.setViewValue();
      };

      ctrl.pathwayExists = function (pathway) {
        return ctrl.pathwayIds.indexOf(pathway.pathway_id) !== -1;
      };

      ctrl.trackExists = function (track) {
        return ctrl.trackIds.indexOf(track.track_id) !== -1;
      };

      ctrl.picmonicExcluded = function (card) {
        return ctrl.excludedCardIds.indexOf(card.card_id) !== -1;
      };

      ctrl.playlistExists = function (playlist) {
        return ctrl.playlistIds.indexOf(playlist.playlist_id) !== -1;
      };

      ctrl.togglePathwayVisibility = function (pathway) {
        pathway.hidden = !pathway.hidden ? 1 : 0;
        Pathways.update(pathway);
      };

      ctrl.toggleTrackVisibility = function (track) {
        track.hidden = !track.hidden ? 1 : 0;
        Tracks.update(track);
      };

      ctrl.getSections();
    },
  ],
});
